export function formatShorthandCount(count) {
  if (count < 1000) {
    return count.toString()
  }

  const abbreviations = [
    { threshold: 1e12, symbol: 'T' },
    { threshold: 1e9, symbol: 'B' },
    { threshold: 1e6, symbol: 'M' },
    { threshold: 1e3, symbol: 'K' },
  ]

  for (const { threshold, symbol } of abbreviations) {
    if (count >= threshold) {
      const value = count / threshold
      if (value < 10) {
        const decimal = value.toFixed(1)
        return decimal.endsWith('.0')
          ? decimal.slice(0, -2) + symbol
          : decimal + symbol
      } else {
        return Math.round(value) + symbol
      }
    }
  }

  return count?.toString() ?? '0'
}

export function mergeObjectByType(data, type, key) {
  if (!Array.isArray(data) || !type || !key) return []

  const merged = data.flatMap((obj) => obj[type] || []).filter(Boolean)

  return merged?.every((item) => key in item)
    ? [
        ...new Map(
          merged.map((item) => [
            item[key],
            { ...item, type: type?.slice(0, -1) },
          ])
        ).values(),
      ]
    : []
}

export function getCategoriesByPublicationType(
  publications,
  categories,
  publicationType
) {
  const filteredCategoryIds = categories
    ?.filter((cat) => cat.publication_type === publicationType)
    ?.map((cat) => cat.id)

  return [
    ...new Map(
      publications
        ?.flatMap((pub) => pub.categories || [])
        ?.filter((cat) => filteredCategoryIds.includes(cat.category_id))
        ?.map((cat) => ({
          ...categories.find((c) => c.id === cat.category_id),
        }))
        .map((cat) => [cat.id, cat]) // Use Map to ensure unique category_id
    ).values(),
  ]
}

export function getPublicationsByCategory(publications, categoryId) {
  if (!Array.isArray(publications) || !categoryId) return []

  return publications?.filter((publication) =>
    publication?.categories.some(
      (category) => category.category_id === categoryId
    )
  )
}

export const isEmptyObject = (obj) => !!obj && Object.keys(obj).length === 0

export const getCountryBasedCurrency = (
  countries,
  currencies,
  detectedCountry
) => {
  const detectedCountryCurrency = countries?.find(
    (c) => c.code === detectedCountry
  )?.currency_id

  const detectedCurrency = currencies?.find(
    (c) => c.id === detectedCountryCurrency
  )?.code

  return detectedCurrency ?? 'USD'
}

// const featuredPublications = computed(() => {
//     return publications.value.filter((publication) =>
//         publication.countries.some(
//             (country) =>
//                 countries.value?.some((c) => c.id === country.id) &&
//                 country?.is_featured
//         )
//     )
// })
